import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// A stale tab (open since before the last deploy) requests a lazy chunk by its
// old content hash, which no longer exists once a new build overwrites it.
// Reload once to pick up the current build; the guard stops a reload loop if
// the chunk is missing for a real reason.
window.addEventListener('error', (event) => {
  const message = event?.message || '';
  const isChunkLoadError = event?.error?.name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/.test(message);
  if (!isChunkLoadError) return;

  if (!sessionStorage.getItem('chunk_reload')) {
    sessionStorage.setItem('chunk_reload', '1');
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Landing routes are prerendered by react-snap, so their HTML arrives already
// populated — hydrate it instead of re-rendering from scratch.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
